import React, { createContext, useContext, useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { baseURL } from '../config'

const SubscriptionContext = createContext()

export const useSubscription = () => {
	const context = useContext(SubscriptionContext)
	if (!context) {
		throw new Error('useSubscription must be used within SubscriptionProvider')
	}
	return context
}

export const SubscriptionProvider = ({ children }) => {
	const [subscriptionData, setSubscriptionData] = useState(null)
	const [loading, setLoading] = useState(true)
	const hasFetched = useRef(false)

	const fetchSubscriptionData = async () => {
		const token = localStorage.getItem('jwtToken')
		if (!token) {
			setLoading(false)
			return
		}

		try {
			setLoading(true)
			const response = await axios.get(`${baseURL}/api/stripe/checkInvoice`)
			setSubscriptionData(response.data)
		} catch (error) {
			console.error('Error fetching subscription:', error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (hasFetched.current) return
		hasFetched.current = true
		fetchSubscriptionData()
	}, [])

	return (
		<SubscriptionContext.Provider
			value={{
				subscriptionData,
				loading,
				refetch: fetchSubscriptionData,
			}}
		>
			{children}
		</SubscriptionContext.Provider>
	)
}
